(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tns-drop-explainer"]) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Reveal the gold timeline (per instance) + no-IO fallback for the editor */
    document.querySelectorAll('.tns-drop-explainer__steps').forEach(function (steps) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { steps.classList.add('is-in'); io.unobserve(e.target); }
          });
        }, { threshold: 0.2 });
        io.observe(steps);
      } else {
        steps.classList.add('is-in');
      }
    });

    /* Tick pulse on countdown digits — disabled under reduced motion */
    if (typeof MutationObserver === 'undefined' || reduce) return;
    document.querySelectorAll('.tns-drop-explainer__num').forEach(function (el) {
      if (el._tnsTickWired) return;
      el._tnsTickWired = true;
      var last = el.textContent;
      var mo = new MutationObserver(function () {
        var now = el.textContent;
        if (now !== last) {
          last = now;
          el.classList.remove('is-ticking');
          void el.offsetWidth; /* reflow so the animation replays */
          el.classList.add('is-ticking');
        }
      });
      mo.observe(el, { characterData: true, childList: true, subtree: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tns-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

    function closeItem(item) {
      var body = item.querySelector('.tns-faq__body');
      item.classList.remove('is-open');
      if (REDUCED.matches || !body) {
        item.open = false;
        return;
      }
      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        if (!item.classList.contains('is-open')) item.open = false;
      };
      body.addEventListener('transitionend', finish, { once: true });
      window.setTimeout(finish, 650);
    }

    function openItem(item, items, single) {
      if (single) {
        items.forEach(function (other) {
          if (other !== item && (other.open || other.classList.contains('is-open'))) closeItem(other);
        });
      }
      item.open = true;
      if (REDUCED.matches) {
        item.classList.add('is-open');
        return;
      }
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          item.classList.add('is-open');
        });
      });
    }

    function initFaq(root) {
      if (!root || root.dataset.tnsFaqInit === 'true') return;
      root.dataset.tnsFaqInit = 'true';
      root.classList.add('is-enhanced');

      var items = Array.prototype.slice.call(root.querySelectorAll('details.tns-faq__item'));
      var single = root.dataset.singleOpen === 'true';

      items.forEach(function (item) {
        var summary = item.querySelector('.tns-faq__summary');
        if (!summary) return;
        if (item.open) item.classList.add('is-open');
        summary.addEventListener('click', function (event) {
          event.preventDefault();
          if (item.classList.contains('is-open')) {
            closeItem(item);
          } else {
            openItem(item, items, single);
          }
        });
      });
    }

    function initAll(scope) {
      var nodes = (scope || document).querySelectorAll('.tns-faq');
      Array.prototype.forEach.call(nodes, initFaq);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var item = event.target;
      if (!item || !item.classList || !item.classList.contains('tns-faq__item')) return;
      if (item.classList.contains('is-open') || item.open) return;
      var summary = item.querySelector('.tns-faq__summary');
      if (summary) summary.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tns-footer"]) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Split headings into per-word reveal spans (idempotent) */
    document.querySelectorAll('.tns-footer [data-split]').forEach(function (el) {
      if (el.dataset.splitDone) return;
      el.dataset.splitDone = '1';
      var words = (el.textContent || '').trim().split(/\s+/);
      el.textContent = '';
      words.forEach(function (w, i) {
        var outer = document.createElement('span');
        outer.className = 'tns-split-word';
        var inner = document.createElement('span');
        inner.textContent = w;
        inner.style.setProperty('--sw-delay', (i * 60) + 'ms');
        outer.appendChild(inner);
        el.appendChild(outer);
        if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
      });
    });

    /* Reveal on scroll (in case the global immersive JS is absent) */
    var revealEls = document.querySelectorAll('.tns-footer [data-reveal], .tns-footer [data-split]');
    if (reduce || !('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
      revealEls.forEach(function (el) { io.observe(el); });
    }

    /* Seamless marquee — clone the track once */
    var mq = document.querySelector('.tns-footer [data-marquee] .tns-marquee');
    if (mq && !reduce) {
      var track = mq.querySelector('.tns-marquee__track');
      if (track && !mq.dataset.cloned) {
        mq.dataset.cloned = '1';
        var clone = track.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        mq.appendChild(clone);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tns-header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-tns-header]');
    var toggleBtn = document.querySelector('[data-mobile-toggle]');
    var closeBtn = document.querySelector('[data-mobile-close]');
    var menu = document.querySelector('[data-mobile-menu]');

    if (header) {
      // offset the fixed header below the announcement bar (if present)
      var ann = document.querySelector('.tns-announcement, [data-tns-announcement]');
      var annSection = ann ? (ann.closest('.shopify-section') || ann) : null;
      function measureAnn() {
        header.style.setProperty('--tns-ann-offset', (annSection ? annSection.offsetHeight : 0) + 'px');
      }
      measureAnn();
      window.addEventListener('resize', measureAnn);

      // hysteresis so classes don't thrash at threshold boundaries (no flicker)
      var lastY = window.scrollY, ticking = false;
      function onScroll() {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          var y = window.scrollY;
          var delta = y - lastY;

          if (y > 64) header.classList.add('is-scrolled');
          else if (y < 16) header.classList.remove('is-scrolled');

          if (Math.abs(delta) > 8) {
            if (y > 320 && delta > 0) header.classList.add('is-hidden');
            else if (delta < 0) header.classList.remove('is-hidden');
            lastY = y;
          }
          if (y <= 320) header.classList.remove('is-hidden');
          ticking = false;
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }

    if (!toggleBtn || !menu) return;
    function open() { menu.hidden = false; toggleBtn.setAttribute('aria-expanded', 'true'); document.body.classList.add('kala-no-scroll'); }
    function close() { menu.hidden = true; toggleBtn.setAttribute('aria-expanded', 'false'); document.body.classList.remove('kala-no-scroll'); }
    toggleBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) close(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tns-narrative-scroll"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.currentScript && document.currentScript.closest
      ? document.currentScript.closest('.tns-narrative-scroll')
      : document.querySelector('.tns-narrative-scroll');
    if (!root) root = document.querySelector('.tns-narrative-scroll');
    if (!root) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Split target headings into animatable words.
       Done locally so the section is self-sufficient even without tns-immersive.js. */
    function splitWords(el) {
      if (!el || el.dataset.splitDone === 'true') return;
      el.dataset.splitDone = 'true';
      var html = el.innerHTML;
      // Preserve <em> emphasis: tokenize on spaces but keep tags attached to words.
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var out = '';
      function walk(node) {
        node.childNodes.forEach(function (child) {
          if (child.nodeType === 3) {
            var words = child.textContent.split(/(\s+)/);
            words.forEach(function (w) {
              if (/^\s+$/.test(w)) { out += ' '; }
              else if (w.length) { out += '<span class="tns-word"><span>' + w + '</span></span>'; }
            });
          } else if (child.nodeType === 1) {
            var tag = child.tagName.toLowerCase();
            out += '<' + tag + '>';
            walk(child);
            out += '</' + tag + '>';
          }
        });
      }
      walk(tmp);
      el.innerHTML = out;
      // stagger delays
      var spans = el.querySelectorAll('.tns-word > span');
      spans.forEach(function (s, i) { s.parentElement.style.setProperty('--w-delay', (i * 45) + 'ms'); });
    }

    if (!reduceMotion) {
      root.querySelectorAll('[data-split]').forEach(splitWords);
    }

    /* IntersectionObserver: add .is-in to reveal chapters, draw lines, split headings. */
    var revealTargets = root.querySelectorAll('[data-reveal], [data-split], .tns-narrative-scroll__chapter');
    if ('IntersectionObserver' in window && !reduceMotion) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
      revealTargets.forEach(function (t) { io.observe(t); });
    } else {
      revealTargets.forEach(function (t) { t.classList.add('is-in'); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tns-social-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.tns-social-carousel').forEach(function (section) {
      var track = section.querySelector('[data-sc-track]');
      var prev = section.querySelector('[data-sc-prev]');
      var next = section.querySelector('[data-sc-next]');
      if (!track) return;

      function step() {
        var tile = track.querySelector('.tns-social-carousel__tile');
        return tile ? tile.getBoundingClientRect().width + 18 : 320;
      }
      function updateArrows() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 4;
        prev.toggleAttribute('disabled', track.scrollLeft <= 4);
        next.toggleAttribute('disabled', track.scrollLeft >= max);
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();

      /* drag to scroll (fine pointers) */
      var down = false, startX = 0, startLeft = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false;
        startX = e.clientX; startLeft = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = startLeft - dx;
      });
      window.addEventListener('pointerup', function () {
        down = false;
        track.classList.remove('is-dragging');
      });
      /* suppress accidental link clicks after a drag */
      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);

      /* keyboard support on the viewport */
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { track.scrollBy({ left: step(), behavior: 'smooth' }); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { track.scrollBy({ left: -step(), behavior: 'smooth' }); e.preventDefault(); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
